<template>
  <h4 class="headerBlue">
    <slot />
  </h4>
</template>

<script>
  export default {
    name: "HeaderBlue"
  }
</script>

<style lang="scss">
  @import "../../../scss/_utilities/_variables";
  .headerBlue{
    background-color: $sinoreg-blue;
    color: $color-white;
    fill: $color-white;
    padding: pxToRem(8);
    font-size: pxToRem(20);
    font-weight: 500;
    height: 100%;
  }
</style>
